// import { Component, OnInit } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit, NgModule, Inject, OnInit, ChangeDetectorRef, Output, EventEmitter, HostListener } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar} from '@angular/material/snack-bar';
import { AuthenticationService } from '../../_services';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { TicketService } from '../../_services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.scss']
})
export class TicketComponent implements OnInit {
  user: any;
  seller_id: any;
  order_id: number = 0;
  selected_tab_principal: number = 0;
  t_token: any;
  vista_anterior = false;
  current_user: any
  
  constructor(
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    this.asignarDatos(); 
    this.selected_tab_principal = 0;
    this.order_id = this.route.snapshot.queryParams['order_id'] || '/';
    if(this.order_id != null && this.order_id > 0){
      this.selected_tab_principal = 1;
    }

    this.t_token = this.route.snapshot.queryParams['t_token'] || '/';
    if(this.t_token != null){
      this.vista_anterior = true;
    }else{
      this.vista_anterior = false;
    }

    this.loadHubSpotScript();
  } 

  private loadHubSpotScript(): void {
    if (document.querySelector('script[src*="hsforms.net"]')) return;
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/50807344.js';
    script.defer = true;
    document.body.appendChild(script);
  }

  tabClickPrincipal(event){
    this.selected_tab_principal = event.index;
    //TODO: probar si no afecta
    if(this.selected_tab_principal == 0){
      this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/tickets']);
      });
    }
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
    
  }

  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }
}

export class TicketsDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number, filtro: string, tk_status: string, tk_motivo: string, tk_noti: string): Observable<TicketApi> {
     const href = `${environment.apiUrl}/rmsfe/query_tickets.json`;
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&keywords=${filtro}&tk_status=${tk_status}&tk_motivo=${tk_motivo}&tk_noti=${tk_noti}`;
    return this._httpClient.get<TicketApi>(requestUrl);
  }
}

export interface TicketApi {
  items: EntradaIssue[];
  total_count: number;
}

export interface EntradaIssue {
  created_at: string;
}  

@Component({
    selector: 'tickets-tab-1',
    templateUrl: './tickets-tab-1.html',
    styleUrls: ['./tickets.component.scss']
})
export class TicketsTab1 implements AfterViewInit {
  
  displayedColumns: string[] = ['ticket_token', 'shopify_name', 'incident_name', 'status_name', 'fecha_estatus', 'notificaciones', 'ver_detalles'];
  ticketsDatabase: TicketsDatabase | null;
  data: EntradaIssue[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  guiaForm: FormGroup;
  keywords = "";
  hay_datos = true;
  titulo_diff = false;
  datos_iniciales = true;
  on_proces = false;
  list_status_tk = [];
  tk_status: FormControl =  new FormControl('', []);
  list_motivo_tk = [];
  tk_motivo: FormControl =  new FormControl('', []);
  tk_noti: FormControl =  new FormControl('', []);
  
  constructor(
    private formBuilder: FormBuilder,
    private _httpClient: HttpClient,
    public dialog: MatDialog,
    private router: Router,
    private ticketService: TicketService
  ) { }
    
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  ngOnInit() {
    this.obtenerStatus();
    this.obtenerMotivos();
  }

  async obtenerStatus(){
    this.ticketService.consultarStatus()
      .pipe(first())
      .subscribe(
        data => {
          if(data["body"]["status"]){
            this.list_status_tk = data["body"]["status"];
          }

        },
        error => {

        }
      );
  }

  async obtenerMotivos(){
    this.ticketService.consultarMotivos()
      .pipe(first())
      .subscribe(
        data => {
          if(data["body"]["motivos"]){
            this.list_motivo_tk = data["body"]["motivos"];
          }

        },
        error => {

        }
      );
  }

  applyFilterStausTicket(){
    this.hacerTabla(this.keywords);
  }

  applyFilterMotivoTicket(){
    this.hacerTabla(this.keywords);
  }

  applyFilterNotificacionesTicket(){
    this.hacerTabla(this.keywords);
  }
    
  ngAfterViewInit() {
    this.ticketsDatabase = new TicketsDatabase(this._httpClient);
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    this.hacerTabla(this.keywords);
  }

  mostrarCard(){
    if(this.datos_iniciales){
      this.titulo_diff = true;
    }else{
      this.titulo_diff = false;
    }
    this.hay_datos = !this.hay_datos;
  }

  hacerTabla(filtros){
    merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.ticketsDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, this.keywords, this.tk_status.value, this.tk_motivo.value, this.tk_noti.value);
        }),
        map(data => {
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          if(data.items.length == 0) {
            this.hay_datos = false 
            this.datos_iniciales = false
          }else{
            this.hay_datos = true 
            this.datos_iniciales = true
          }

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }

  openDialog(entrada_token) {

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue.trim().toLowerCase();
    this.hacerTabla(this.keywords);
  }

  verDetallesTicket(row){
    this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/tickets'], { queryParams: { order_id: row.shopi_order_id, t_token: row.ticket_token }});
    });
  }

}

export class DataTabOrdTickDatabase {
  constructor(private _httpClient: HttpClient) {}
  
  getRepoIssues(sort: string, order: string, page: number, filtro1: string, filtro2: string, filtro3: string): Observable<OrdenTickApi> {
    
    const href = `${environment.apiUrl}/rmsfe/shopi_orders_to_ticket.json`;

      let baseParams = new HttpParams().set('sort', sort);
      baseParams = baseParams.set('order', order);
      baseParams = baseParams.set('page', `${page + 1}`);
      baseParams = baseParams.set('keywordsCanal', filtro1);
      baseParams = baseParams.set('keywordsOrden', filtro2);
      baseParams = baseParams.set('keywordsOrdenMKTF', filtro3);

      
      return this._httpClient.get<OrdenTickApi>(href, 
        {params: baseParams}
      );
  }
}

export interface OrdenTickApi {
  items: OrderTicketIssue[];
  total_count: number;
}

export interface OrderTicketIssue {
  created_at: string;
} 

@Component({
    selector: 'tickets-tab-2',
    templateUrl: './tickets-tab-2.html',
    styleUrls: ['./tickets.component.scss']
})
export class TicketsTab2 implements AfterViewInit {

  displayedColumns: string[] = [
    'canal', 
    'shopify_name',
    'id',
    'cliente',  
    'fulfillment_status',
    'ticket_orden'
  ];
  dataTabOrdTickDatabase: DataTabOrdTickDatabase | null;
  data: EntradaIssue[] = [];
  keywordsinput = "";

  deshabilitado_tab1 = true;
  deshabilitado_tab2 = true;
  deshabilitado_tab3 = true;
  selected_tab: number = 0;

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  keywordsCanal = "";
  keywordsOrden = "";
  keywordsOrdenMKTF = "";
  motivo_seleccionado = "";
  hay_datos = true;
  titulo_diff = false;
  spinner = false;
  hidden_data = true;
  order_id: number = 0;
  t_token: any;
  vista_anterior = false;
  current_user: any;
  delayTimer: any;

  constructor(
    private formBuilder: FormBuilder,
    private _httpClient: HttpClient,
    public dialog: MatDialog,
    private router: Router,
    private ticketService: TicketService,
    private route: ActivatedRoute,
    private ticketComponent: TicketComponent,
    private authenticationService: AuthenticationService

  ) { }
    
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  ngOnInit() {
    this.asignarDatos();
    this.selected_tab = 0;
    this.motivo_seleccionado = "";
    if(this.ticketComponent.selected_tab_principal != 0 && this.ticketComponent.order_id != 0){
      this.selected_tab = 0;
      this.hidden_data = false;
      this.deshabilitado_tab1 = false;
      this.order_id = this.ticketComponent.order_id;
    }

    if(this.ticketComponent.t_token != null && this.ticketComponent.vista_anterior != false){
      this.t_token = this.ticketComponent.t_token;
      this.vista_anterior = this.ticketComponent.vista_anterior;
    }else{
      this.t_token = 0;
      this.vista_anterior = false;
    }
  }
    
  ngAfterViewInit() {
    this.dataTabOrdTickDatabase = new DataTabOrdTickDatabase(this._httpClient);
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    this.hacerTabla();
  }

  applyFilterCanal(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywordsCanal = filterValue.trim().toLowerCase();
    this.hacerTabla();
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
    
  }

  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }
  
  applyFilterOrden(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywordsOrden = filterValue.trim().toLowerCase();
    this.hacerTabla();
  }
  
  applyFilterOrdenMKTF(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywordsOrdenMKTF = filterValue.trim().toLowerCase();
    this.hacerTabla();
  }

  hacerTabla(){
    clearTimeout(this.delayTimer);
    this.delayTimer = setTimeout(() => {
      merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.dataTabOrdTickDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, this.keywordsCanal, this.keywordsOrden, this.keywordsOrdenMKTF);
        }),
        map(data => {
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          
          if(data.items.length == 0) {
            this.hay_datos = false 
          }else{
            this.hay_datos = true 
          }
          
          this.spinner = false;
            return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
          this.spinner = false;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
    }, 500);
  }

  consultarOrden(order_id){
    this.ticketService.consultarOrden(order_id)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.dialog.open(DialogDetTic1 ,{width:'90vw', height: '90%',disableClose: false ,data: {params: data}});
        }
      },
      error => {
    });
  }

  generarTicketOrden(order){
    this.selected_tab = 0;
    this.hidden_data = false;
    this.deshabilitado_tab1 = false;
    this.order_id = order.id;
    this.router.navigate(['/tickets'], { queryParams: { order_id: this.order_id }});
  }

  tabClick(event){
    this.selected_tab = event.index;
  }

  regresarTabla(){
    this.selected_tab = null;
    this.hidden_data = true;
    this.deshabilitado_tab1 = true;
    this.deshabilitado_tab2 = true;
    this.deshabilitado_tab3 = true;
    if(this.t_token > 0 && this.vista_anterior != false){
      this.ticketComponent.selected_tab_principal = 0;
    }
    this.t_token = 0;
    this.vista_anterior = false;
    this.ticketComponent.t_token = 0; 
    this.ticketComponent.vista_anterior = false;
    this.order_id = 0;
  }

  generarFulfillment(){
    this.deshabilitado_tab2 = false;
    this.deshabilitado_tab3 = true;
    this.selected_tab = 1;
  }

  generarDevolucion(){
    this.deshabilitado_tab2 = true;
    this.deshabilitado_tab3 = false;
    this.selected_tab = 2;
  }

}

export interface ProductosTicket {
  sku: string;
  producto: string;
  cantidad: number;
}

@Component({
  selector: 'dialog-1-det',
  templateUrl: './dialog-1-det.html',
  styleUrls: ['./tickets.component.scss'],
})
export class DialogDetTic1 {
  params : any;
  usuario: string;
  datos_tabla: ProductosTicket[] = []
  displayedColumns = ['sku', 'producto', 'cantidad'];
  order_id: any;
  spinner = false;

  constructor(
    public dialogRef: MatDialogRef<DialogDetTic1>,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
    if(this.data.params){
      this.params = this.data.params.body;
      this.datos_tabla = this.params["items"];
      this.order_id = this.params["orden"]["id"]
      this.datos_tabla = this.datos_tabla.filter((value,key)=>{
        return value;
      });
    }

    this.authenticationService.currentUser.subscribe(x => this.usuario = x);
    if(this.usuario){
      this.usuario = this.usuario['seller_id'];
    }
  }

  ngOnInit(){

  }

  closeDialog() {
    this.dialogRef.close();
  }

}

export interface HistorialOrden {
  event_time: string;
  event_name: string;
  nota_cliente: string;
}
@Component({
  selector: 'tickets-tab-2-sub-1',
  templateUrl: './tickets-tab-2-sub-1.html',
  styleUrls: ['./tickets.component.scss']
})
export class TicketsTab2Sub1 implements AfterViewInit {

  ticketDatosForm: FormGroup;
  motivosList = [];
  formsMotivo: FormControl;
  formFile: FormControl;
  error: string;
  show_card_chat = false;
  fileToUpload: File = null;
  order_id: number = 0;
  spinner = false;
  file_name: string;
  usuario: string;
  user: any;
  user_id: any;
  btn_disabled = false;
  t_token: any;
  isLoaResTab = false;
  btn_download = false;
  download_url =  '';
  datos_tabla_historial: HistorialOrden[] = []
  displayedColumnsOrden = ['event_time', 'event_name', 'nota_cliente'];
  ticket_id: any;
  comentariosDatosForm: FormGroup;
  comentarioTicket: FormControl;
  formCometFile: FormControl;
  fileToUploadComnet: File = null;
  file_name_coment: string;
  historialComentariosList = [];
  inf_tic_t_token = "";
  inf_tic_shopify_name = "";
  inf_tic_status_name = "";
  comen_disabled = false;
  t_s_id = null;
  current_user: any;
  
  constructor(
    private formBuilder: FormBuilder,
    private _httpClient: HttpClient,
    public dialog: MatDialog,
    private router: Router,
    public ticketsTab2: TicketsTab2,
    private ticketService: TicketService,
    private snackBar: MatSnackBar,
    private authenticationService: AuthenticationService,
  ) { 
    this.authenticationService.currentUser.subscribe(x => this.usuario = x);
    if(this.usuario){
      this.usuario = this.usuario['seller_id'];
    }

    this.authenticationService.currentUser.subscribe(x => this.user = x);
      if(this.user){
        this.user_id = this.user["id"];
      }
  }
  
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
      if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
        //this.cambiarEstadoMensajes();
      }
  }

  ngOnInit() {
    this.asignarDatos(); 
    this.ticketDatosForm = this.formBuilder.group({
      formsMotivo: ['', Validators.required],
      formFile: ['', ],
    });

    this.formsMotivo = new FormControl('', [Validators.required]);
    this.formFile = new FormControl('', );

    this.comentariosDatosForm = this.formBuilder.group({
      comentarioTicket: ['', Validators.required],
      formCometFile: ['', ],
    });

    this.comentarioTicket = new FormControl('', [Validators.required]);
    this.formCometFile = new FormControl('', );

    this.inf_tic_t_token = "";
    this.inf_tic_shopify_name = "";
    this.inf_tic_status_name = "";
    this.comen_disabled = false;
    this.t_s_id = null;

    this.obtenerMotivos();
    this.obtenerHistorialComentarios();
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
    
  }

  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }

  ngDoCheck() {
    this.order_id = this.ticketsTab2.order_id;

    if(this.ticketsTab2.t_token != null && this.ticketsTab2.t_token != '/' && this.ticketsTab2.t_token > 0){
      this.t_token = this.ticketsTab2.t_token;
      this.loadInfoTicket();
    }
  }

  loadInfoTicket(){
    if(this.t_token != null && !this.isLoaResTab){
      this.isLoaResTab = true;
      this.ticketService.consultarInfoTicket(this.t_token)
      .pipe(first())
      .subscribe(
        data => {
          if(data.status == 200){
            this.show_card_chat = true;
            this.btn_disabled = true;
            this.formsMotivo.setValue(data.body["ticket_info"].incident_type_id);
            if(data.body["download_url"] != null){
              this.download_url = data.body["download_url"];
              this.btn_download = true;
            }
            this.inf_tic_t_token = data.body["ticket_info"].ticket_token;
            this.inf_tic_shopify_name = data.body["ticket_info"].shopify_name;
            this.inf_tic_status_name = data.body["ticket_info"].status_name;
            this.ticketsTab2.motivo_seleccionado = data.body["ticket_info"].incident_name;

            this.t_s_id = data.body["ticket_info"].ticket_status_id;
            if(data.body["ticket_info"].ticket_status_id == 2){
              this.comen_disabled = true;
            }else{
              this.comen_disabled = false;
            }

            this.datos_tabla_historial = data.body["historial"];

            this.ticket_id = data.body["ticket_info"].id;
            this.obtenerHistorialComentarios();
          }
          this.isLoaResTab = true;
          this.cambiarEstadoMensajes();
        },
        error => {
          this.isLoaResTab = false;
        }
      );
    }
  }

  onResize(event) {

  }
  
  ngAfterViewInit() {

  }

  regresarTabla(){
    this.ticketsTab2.regresarTabla();
    this.formsMotivo.setValue('');
    this.formsMotivo.reset();
    this.formFile.setValue('');
    this.formFile.reset();
    this.show_card_chat = false;
    this.btn_disabled = false;
    this.btn_download = false;
    this.t_token = null;
    this.isLoaResTab = false;
    this.download_url = null;
    this.ticket_id = null;
    this.order_id = 0;
    this.inf_tic_t_token = "";
    this.inf_tic_shopify_name = "";
    this.inf_tic_status_name = "";
    this.ticketsTab2.motivo_seleccionado = "";
    this.comen_disabled = false;
    this.t_s_id = null;
    this.router.navigate(['/tickets']);
  }

  async obtenerMotivos(){
    this.ticketService.consultarMotivos()
      .pipe(first())
      .subscribe(
        data => {
          if(data["body"]["motivos"]){
            this.motivosList = data["body"]["motivos"];
          }

        },
        error => {

        }
      );
  }

  generarTicket(){

    if (this.formsMotivo.invalid){
      return;
    }

    this.spinner = true;
    this.ticketService.generarTicket(this.usuario, this.formsMotivo.value, this.order_id, this.file_name, this.user_id)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.spinner = false;
          this.show_card_chat = true;
          this.btn_disabled = true;
          if(data.ticket_id){
            this.ticket_id = data.ticket_id;
          }
          if(this.t_token == null || this.t_token == '/'){
            this.t_token = data.ticket_token;
          }
          this.isLoaResTab = false;
          this.loadInfoTicket();
          this.snackBar.open("El Ticket se genero correctamente", "OK", {                      
            duration: 3500,
          });
          this.router.navigate(['/tickets'], { queryParams: { order_id: this.order_id, t_token: this.t_token }});
        }else{
          this.error = data.body["message"];
          this.spinner = false;
          this.snackBar.open("Ocurrió un error al generar el Ticket, intentelo de nuevo.", "OK", {                      
            duration: 3500,
          });
        }
      },
      error => {
        this.error = error;
        this.spinner = false;
        this.snackBar.open("Ocurrió un error al generar el Ticket, intentelo de nuevo.", "OK", {                      
          duration: 3500,
        });
   });
  }

  handleFileInput(files: FileList) {
    this.spinner = true;
    this.formFile.disable();
    this.fileToUpload = files.item(0);

    this.ticketService.getUploadURl(this.fileToUpload.type)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.subirAWS(data.body["data"], this.fileToUpload);
        }else{

        }
      },
      error => {
    });
  }

  subirAWS(response, fileToUpload){
    this.ticketService.subirArchivo(response.url, fileToUpload)
    .pipe(first())
    .subscribe(
      data => {
        this.file_name = response.file_name;
        this.spinner = false;
        this.formFile.enable();
        this.snackBar.open("La guía se cargó correctamente", "OK", {                      
          duration: 3500,
        });
      },
      error => {
        this.spinner = false;
        this.formFile.enable();
        this.snackBar.open("Ocurrió un error al cargar la guía, intentelo de nuevo.", "OK", {                      
          duration: 3500,
        });
    });
  }

  generarFulfillment(){
    this.router.navigate(['/tickets'], { queryParams: { order_id: this.order_id, t_token: this.t_token }});
    this.ticketsTab2.generarFulfillment();
  }

  generarDevolucion(){
    this.router.navigate(['/tickets'], { queryParams: { order_id: this.order_id, t_token: this.t_token }});
    this.ticketsTab2.generarDevolucion();
  }

  enviarComentarioTicket(){
    if (this.comentarioTicket.invalid){
      return;
    }

    this.ticketService.enviarComentarioTicket(this.usuario, this.comentarioTicket.value, this.order_id, this.file_name_coment, this.user_id, this.ticket_id)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.snackBar.open("Comentario enviado", "OK", {                      
            duration: 3500,
          });
          this.comentarioTicket.reset();
          this.comentarioTicket.setValue('');
          
          this.fileToUploadComnet = null;
          this.file_name_coment = null;
          this.formCometFile.setValue('');
          this.formCometFile.reset();

          this.comentariosDatosForm.reset();

          this.comentariosDatosForm.get('comentarioTicket').setErrors(null);
          
          this.obtenerHistorialComentarios();
        }else{
          this.snackBar.open("Ocurrió un error al enviar el comentario, intentelo de nuevo.", "OK", {                      
            duration: 3500,
          });
        }
      },
      error => {
        this.snackBar.open("Ocurrió un error al enviar el comentario, intentelo de nuevo.", "OK", {                      
          duration: 3500,
        });
   });
  }

  handleFileInputComent(files: FileList) {
    this.spinner = true;
    this.formCometFile.disable();
    this.fileToUploadComnet = files.item(0);

    this.ticketService.getUploadURl(this.fileToUploadComnet.type)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.subirAWSComent(data.body["data"], this.fileToUploadComnet);
        }else{

        }
      },
      error => {
    });
  }

  subirAWSComent(response, fileToUpload){
    this.ticketService.subirArchivo(response.url, fileToUpload)
    .pipe(first())
    .subscribe(
      data => {
        this.file_name_coment = response.file_name;
        this.spinner = false;
        this.formCometFile.enable();
        this.snackBar.open("El archivo se cargó correctamente", "OK", {                      
          duration: 3500,
        });
      },
      error => {
        this.formCometFile.enable();
        this.spinner = false;
        this.snackBar.open("Ocurrió un error al cargar el archivo, intentelo de nuevo.", "OK", {                      
          duration: 3500,
        });
    });
  }

  async obtenerHistorialComentarios(){
    if(this.ticket_id != null){
      this.ticketService.consultarHistorialComentarios(this.ticket_id)
        .pipe(first())
        .subscribe(
          data => {
            if(data["body"]["hitorial"]){
              this.historialComentariosList = data["body"]["hitorial"];
            }
          },
          error => {

          }
        );
    }
  }

  cambiarEstadoMensajes(){
    this.ticketService.cambiarEstadoMensajes(this.ticket_id)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
        }else{
        }
      },
      error => {
   });
  }

  preguntarGuia(){
    if(this.t_s_id != null && this.t_s_id == 2){
        const dialogRef = this.dialog.open(DialogPreguntaReabrir, {width:'450px', height: 'auto',disableClose: true});
        dialogRef.afterClosed().subscribe(result => {
          if (result == true){
            this.reabrirTicket();
          }
        });
      
    }else{
      this.snackBar.open("Error, el ticket no esta cerrado", "OK", {                      
        duration: 5000,
      });
    } 
  }

  reabrirTicket(){
    this.ticketService.cambiarEstadoTicket(this.ticket_id, 3)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.snackBar.open("El ticket fue reabierto", "OK", {                      
            duration: 5000,
          });
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/tickets'], { queryParams: { order_id: this.order_id, t_token: this.t_token }});
          });
        }else{
        }
      },
      error => {
   });
  }

}

export interface ProductosFulfillment {
  sku: string;
  producto: string;
  cantidad: number;
}

@Component({
  selector: 'tickets-tab-2-sub-2',
  templateUrl: './tickets-tab-2-sub-2.html',
  styleUrls: ['./tickets.component.scss']
})
export class TicketsTab2Sub2 implements AfterViewInit {

  ord_id_rec: number = -1;
  isLoaResTab = false;
  entradaFinal: ProductosFulfillment[] = [];
  datos_tabla: ProductosFulfillment[] = [];
  breakpoint: number;
  columna1: number;
  columna2: number;
  columna3: number;
  keywordsinput = "";
  devolucionDatabaseItems: DevolucionDatabaseItems | null;
  dataItems: ItemsIssue[] = [];

  itemForm = new FormControl('', [
    Validators.required,
  ]);

  cantidadForm = new FormControl('', [
    Validators.required,
    Validators.min(1),
  ]);

  filterName:string;
  filterCantidad: string;
  spinner = false;

  displayedColumnsTic = ['sku', 'producto', 'cantidad', 'action'];
  tiene_guia = false;
  t_token: any;
  constructor(
    private formBuilder: FormBuilder,
    private _httpClient: HttpClient,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private ticketService: TicketService,
    private snackBar: MatSnackBar,
  ) { }
  
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  onResize(event) {
    this.breakpoint = (event.target.innerWidth <= 599) ? 1 : 6;
    this.columna1 = (window.innerWidth <= 599) ? 1 : 3;
    this.columna2 = (window.innerWidth <= 599) ? 1 : 2;
    this.columna3 = (window.innerWidth <= 599) ? 1 : 1;
  }

  ngOnInit() {
    this.breakpoint = (window.innerWidth <= 599) ? 1 : 6;
    this.columna1 = (window.innerWidth <= 599) ? 1 : 3;
    this.columna2 = (window.innerWidth <= 599) ? 1 : 2;
    this.columna3 = (window.innerWidth <= 599) ? 1 : 1;

    this.devolucionDatabaseItems = new DevolucionDatabaseItems(this._httpClient);
    this.hacerAutcomplete(this.keywordsinput);

    this.ord_id_rec = -1;
    this.addItemsOrder();

    this.t_token = null;
  }

  ngDoCheck(){
    if(this.ord_id_rec == -1){
      this.ord_id_rec = this.route.snapshot.queryParams['order_id'] || '-1';
    }else{
      this.addItemsOrder();
    }

    if(this.ord_id_rec != -1){
      var or_id_re = this.route.snapshot.queryParams['order_id'] || '-1';
      if(or_id_re == '-1'){
        this.ord_id_rec = -1;
      }
    }

    if(this.t_token == null){
      this.t_token = this.route.snapshot.queryParams['t_token'] || null;
    }

    if(this.t_token != null){
      var t_t = this.route.snapshot.queryParams['t_token'] || null;
      if(t_t == null){
        this.t_token = null;
      }
    }
  }

  addItemsOrder(){
    if(this.ord_id_rec != -1 && !this.isLoaResTab){
      this.isLoaResTab = true;
      this.datos_tabla = [];
      this.entradaFinal = [];
      this.ticketService.consultarOrden(this.ord_id_rec)
      .pipe(first())
      .subscribe(
        data => {
          let items = data["body"]["items"];
          for (let index = 0; index < items.length; index++) {
            this.addItem(this.entradaFinal, items[index].seller_sku, items[index].cantidad, items[index].nombre_producto, items[index].item_id);
          }
          this.datos_tabla = this.entradaFinal;
          this.isLoaResTab = true;
        },
        error => {
          this.isLoaResTab = false;
        }
      );
    }
  }

  addItem(arr, seller_sku, quantity, titulo, item_id) {
    let { length } = arr;
    let id = length + 1;
    let found = arr.some(el => el.sku === seller_sku);
    if (!found){
      arr.push({sku: seller_sku, producto: titulo, cantidad: quantity, item_id: item_id});
    }else{
      let index = arr.findIndex(x => x.sku === seller_sku);
      arr[index].cantidad = arr[index].cantidad + quantity;
    }
    return arr;
  }
  
  ngAfterViewInit() {

  }

  applyFilterInput(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywordsinput = filterValue.trim().toLowerCase();
    this.hacerAutcomplete(this.keywordsinput);
  }

  hacerAutcomplete(filtros){
    merge()
    .pipe(
      startWith({}),
      switchMap(() => {
        return this.devolucionDatabaseItems!.getRepoIssues(filtros);
      }),
      map(data => {
        return data.items;
      }),
      catchError(() => {
        return observableOf([]);
      })
    ).subscribe(data => this.dataItems = data);
  }

  displayFn(subject){
    if(subject){
      if(subject.seller_sku){
        return subject.seller_sku;
      }else if(subject.title){
        return subject.title;
      }
    }else{
      return undefined;
    }
  }

  validarDatos(){
    if(this.itemForm.invalid || this.cantidadForm.invalid){
      return;
    }
    var elItem = this.itemForm.value;
    if(!elItem){
      return;
    }
    
    this.filterName = "";
    this.filterCantidad = "";
    let producto = elItem.title;
    let item_id = elItem.id;
    let el_seller_sku = elItem.seller_sku;
    if(!(typeof elItem === 'object' && elItem !== null)){
      this.snackBar.open("Debes seleccionar un producto de la lista", "OK", {                      
        duration: 5000,
      });
      return;
    }
    this.addItem(this.entradaFinal, el_seller_sku, this.cantidadForm.value, producto, item_id);
    this.datos_tabla = this.entradaFinal;
    this.datos_tabla = this.datos_tabla.filter((value,key)=>{
      return value;
    });
  }

  getTotalCost() {
    return this.datos_tabla.map(t => t.cantidad).reduce((acc, value) => acc + value, 0);
  }

  deleteRowData(row_obj){
    this.datos_tabla = this.datos_tabla.filter((value,key)=>{
      return value.sku != row_obj.sku;
    });
    this.entradaFinal = this.datos_tabla;
  }

  preguntarFulfillTicket(){
    const dialogRef = this.dialog.open(DialogPreguntaFulfillment, {width:'450px', height: 'auto',disableClose: true});

    dialogRef.afterClosed().subscribe(result => {
      if (result == true){
        this.tiene_guia = true;
      }else{
        this.tiene_guia = false;
      }
      this.enviarEntrada();

    });
  }

  enviarEntrada(){
    if(this.datos_tabla.length > 0){
      const dialogRef2 = this.dialog.open(DialogGenerarFF ,{width:'450px', height: 'auto',disableClose: true ,data: {entrada_final: this.entradaFinal, tiene_guia: this.tiene_guia, t_token: this.t_token}});

      dialogRef2.afterClosed().subscribe(result => {
        if(result){
          this.spinner = true;
          this.consultarStatusOrden(result);
        }
      });
    }else{
      this.snackBar.open("Primero debes agregar productos a la Orden", "OK", {                      
        duration: 3500,
      });
    }
  }

  consultarStatusOrden(order_id){
    this.ticketService.consultarStatusOrden(order_id)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          if(data.body["result"][0] == 200){
            this.consultarOrden(order_id);
          }else{
            setTimeout(() => 
            {
              this.consultarStatusOrden(order_id);
            },3000);
          }
        }
      },
      error => {
    });
  }

  consultarOrden(order_id){
    this.ticketService.consultarOrdenFF(order_id)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.spinner = false;
          const dialogRef3 = this.dialog.open(DialogGuiaFF1 ,{width:'90vw', height: '90%',disableClose: false ,data: {params: data, order_id: this.ord_id_rec, t_token: this.t_token}});  
          this.entradaFinal = [ ] 
          this.datos_tabla = [ ]
          dialogRef3.afterClosed().subscribe(result => {
          });
        }
      },
      error => {
    });
  }

}

export interface ProductosDevolucion {
  sku: string;
  producto: string;
  cantidad: number;
}

export class DevolucionDatabaseItems {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(filtro: string): Observable<EntradabApi2> {
    const href = `${environment.apiUrl}/rmsfe/listar_items.json`;
    const requestUrl = `${href}?nombre_producto=${filtro}`;
    return this._httpClient.get<EntradabApi2>(requestUrl);
  }
}

export interface EntradabApi2 {
  items: ItemsIssue[];
  total_count: number;
}

export interface ItemsIssue {
  id: number;
  seller_sku: string;
  title: string;
}

@Component({
  selector: 'tickets-tab-2-sub-3',
  templateUrl: './tickets-tab-2-sub-3.html',
  styleUrls: ['./tickets.component.scss']
})
export class TicketsTab2Sub3 implements AfterViewInit {

  itemForm = new FormControl('', [
    Validators.required,
  ]);

  cantidadForm = new FormControl('', [
    Validators.required,
    Validators.min(1),
  ]);

  filterName:string;
  filterCantidad: string;
  entradaFinal:ProductosDevolucion[] = [];
  datos_tabla: ProductosDevolucion[] = [];
  displayedColumnsTic = ['sku', 'producto', 'cantidad', 'action'];
  breakpoint: number;
  columna1: number;
  columna2: number;
  columna3: number;
  keywordsinput = "";
  devolucionDatabaseItems: DevolucionDatabaseItems | null;
  dataItems: ItemsIssue[] = [];
  checkInvRec: FormControl;
  ord_id_rec: number = -1;
  isLoaResTab = false;
  spinner = false;
  show_card_gen_gui = false;
  guiaDatosForm: FormGroup;
  formsPai: FormControl;
  formCall: FormControl;
  formColonia: FormControl;
  formNumExt: FormControl;
  formNumInt: FormControl;
  formCodPos: FormControl;
  formCiu: FormControl;
  formsEst: FormControl;
  formTel: FormControl;
  formCor: FormControl;
  formPeso: FormControl;
  formLar: FormControl;
  formAnc: FormControl;
  formAlt: FormControl;
  formCusto: FormControl;
  tipoPaqueteList = [];
  formsPaqu: FormControl;
  tipo_empaque: "";
  usuario_gen_guia: string;
  t_token: any = null;
  
  constructor(
    private formBuilder: FormBuilder,
    private _httpClient: HttpClient,
    public dialog: MatDialog,
    private router: Router,
    private snackBar: MatSnackBar,
    public ticketsTab2: TicketsTab2,
    private ticketService: TicketService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
  ) { 
    this.authenticationService.currentUser.subscribe(x => this.usuario_gen_guia = x);
    if(this.usuario_gen_guia){
      this.usuario_gen_guia = this.usuario_gen_guia['seller_id'];
    }
  }
  
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  ngOnInit() {
    this.breakpoint = (window.innerWidth <= 599) ? 1 : 6;
    this.columna1 = (window.innerWidth <= 599) ? 1 : 3;
    this.columna2 = (window.innerWidth <= 599) ? 1 : 2;
    this.columna3 = (window.innerWidth <= 599) ? 1 : 1;

    this.devolucionDatabaseItems = new DevolucionDatabaseItems(this._httpClient);
    this.hacerAutcomplete(this.keywordsinput);

    this.checkInvRec = new FormControl('', []);
    this.checkInvRec.setValue(false);

    this.ord_id_rec = -1;
    this.addItemsOrder();

    this.show_card_gen_gui = false;

    this.guiaDatosForm = this.formBuilder.group({
      formsPai: ['', Validators.required],
      formCall: ['', Validators.required],
      formColonia: ['', Validators.required],
      formNumExt: ['', Validators.required],
      formNumInt: [''],
      formCodPos: ['', Validators.required],
      formCiu: ['', Validators.required],
      formsEst: ['', Validators.required],
      formTel: ['', Validators.required],
      formCor:['', [Validators.required, Validators.email]],
      formPeso: ['', Validators.required],
      formLar: ['', Validators.required],
      formAnc: ['', Validators.required],
      formAlt: ['', Validators.required],
      formsPaqu: ['', Validators.required],
      formCusto: ['', Validators.required],
    });

    this.formsPai = new FormControl('MX', [Validators.required]);
    this.formCall = new FormControl('', [Validators.required]);
    this.formColonia = new FormControl('', [Validators.required]);
    this.formNumExt = new FormControl('', [Validators.required]);
    this.formNumInt = new FormControl('', []);
    this.formCodPos = new FormControl('', [Validators.required]);
    this.formCiu = new FormControl('', [Validators.required]);
    this.formsEst = new FormControl('', [Validators.required]);
    this.formTel = new FormControl('', [Validators.required]);
    this.formCor = new FormControl('', [
      Validators.required,
      Validators.email,
    ]);
    this.formPeso = new FormControl('', [Validators.required]);
    this.formLar = new FormControl('', [Validators.required]);
    this.formAnc = new FormControl('', [Validators.required]);
    this.formAlt = new FormControl('', [Validators.required]);
    this.formsPaqu = new FormControl('', [Validators.required]);
    this.formCusto = new FormControl('', [Validators.required]);

    this.t_token = null;
  }

  ngDoCheck(){
    if(this.ord_id_rec == -1){
      this.ord_id_rec = this.route.snapshot.queryParams['order_id'] || '-1';
    }else{
      this.addItemsOrder();
    }

    if(this.ord_id_rec != -1){
      var or_id_re = this.route.snapshot.queryParams['order_id'] || '-1';
      if(or_id_re == '-1'){
        this.ord_id_rec = -1;
      }
    }

    if(this.t_token == null){
      this.t_token = this.route.snapshot.queryParams['t_token'] || null;
    }

    if(this.t_token != null){
      var t_t = this.route.snapshot.queryParams['t_token'] || null;
      if(t_t == null){
        this.t_token = null;
      }
    }
  }
  
  ngAfterViewInit() {

  }

  validarDatos(){
    if(this.itemForm.invalid || this.cantidadForm.invalid){
      return;
    }
    var elItem = this.itemForm.value;
    if(!elItem){
      return;
    }
    
    this.filterName = "";
    this.filterCantidad = "";
    let producto = elItem.title;
    let item_id = elItem.id;
    let el_seller_sku = elItem.seller_sku;
    if(!(typeof elItem === 'object' && elItem !== null)){
      this.snackBar.open("Debes seleccionar un producto de la lista", "OK", {                      
        duration: 5000,
      });
      return;
    }
    this.addItem(this.entradaFinal, el_seller_sku, this.cantidadForm.value, producto, item_id);
    this.datos_tabla = this.entradaFinal;
    this.datos_tabla = this.datos_tabla.filter((value,key)=>{
      return value;
    });
  }

  addItem(arr, seller_sku, quantity, titulo, item_id) {
    let { length } = arr;
    let id = length + 1;
    let found = arr.some(el => el.sku === seller_sku);
    if (!found){
      arr.push({sku: seller_sku, producto: titulo, cantidad: quantity, item_id: item_id});
    }else{
      let index = arr.findIndex(x => x.sku === seller_sku);
      arr[index].cantidad = arr[index].cantidad + quantity;
    }
    return arr;
  }

  onResize(event) {
    this.breakpoint = (event.target.innerWidth <= 599) ? 1 : 6;
    this.columna1 = (window.innerWidth <= 599) ? 1 : 3;
    this.columna2 = (window.innerWidth <= 599) ? 1 : 2;
    this.columna3 = (window.innerWidth <= 599) ? 1 : 1;
  }

  displayFn(subject){
    if(subject){
      if(subject.seller_sku){
        return subject.seller_sku;
      }else if(subject.title){
        return subject.title;
      }
    }else{
      return undefined;
    }
  }

  applyFilterInput(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywordsinput = filterValue.trim().toLowerCase();
    this.hacerAutcomplete(this.keywordsinput);
  }

  hacerAutcomplete(filtros){
    merge()
    .pipe(
      startWith({}),
      switchMap(() => {
        return this.devolucionDatabaseItems!.getRepoIssues(filtros);
      }),
      map(data => {
        return data.items;
      }),
      catchError(() => {
        return observableOf([]);
      })
    ).subscribe(data => this.dataItems = data);
  }

  deleteRowData(row_obj){
    this.datos_tabla = this.datos_tabla.filter((value,key)=>{
      return value.sku != row_obj.sku;
    });
    this.entradaFinal = this.datos_tabla;
  }

  getTotalCost() {
    return this.datos_tabla.map(t => t.cantidad).reduce((acc, value) => acc + value, 0);
  }

  addItemsOrder(){
    if(this.ord_id_rec != -1 && !this.isLoaResTab){
      this.isLoaResTab = true;
      this.datos_tabla = [];
      this.entradaFinal = [];
      this.ticketService.consultarOrden(this.ord_id_rec)
      .pipe(first())
      .subscribe(
        data => {
          let items = data["body"]["items"];
          for (let index = 0; index < items.length; index++) {
            this.addItem(this.entradaFinal, items[index].seller_sku, items[index].cantidad, items[index].nombre_producto, items[index].item_id);
          }
          this.datos_tabla = this.entradaFinal;
          this.isLoaResTab = true;
        },
        error => {
          this.isLoaResTab = false;
        }
      );
    }
  }

  preguntarGuia(){
    if(this.datos_tabla.length > 0 && this.entradaFinal.length > 0){
      if(this.verificarArreglo(this.datos_tabla) && this.verificarArreglo(this.entradaFinal)){
        const dialogRef = this.dialog.open(DialogPreguntaDevolucion, {width:'450px', height: 'auto',disableClose: true});
        dialogRef.afterClosed().subscribe(result => {
          if (result == true){
            this.procesarDevolucionOrden();
          }else{
            this.generarGuiaRetorno();
          }
        });
      }else{
        this.snackBar.open("Error, los productos deben tener una cantidad mayor 0", "OK", {                      
          duration: 5000,
        });
      }
    }else{
      this.snackBar.open("Error, debe agregar al menos un producto en la tabla", "OK", {                      
        duration: 5000,
      });
    } 
  }

  verificarArreglo(arr) {
    let valido = true;
    for (let index = 0; index < arr.length; index++) {
      if(arr[index].cantidad <= 0){
        valido = false;
        break;
      }  
    }
    return valido;
  }

  procesarDevolucionOrden(){
    this.show_card_gen_gui = false;
    this.resetInputsGenGuiRet();
    const dialogRef2 = this.dialog.open(DialogSubirGuia ,{width:'450px', height: 'auto',disableClose: true ,data: {entrada_final: this.entradaFinal, ord_id_url: this.ord_id_rec, checkInvRec: this.checkInvRec.value, t_token: this.t_token}});
    dialogRef2.afterClosed().subscribe(result => {

    });    
  }

  resetInputsGenGuiRet(){
    this.formsPai.setValue('MX');
    this.formCall.setValue('');
    this.formColonia.setValue('');
    this.formNumExt.setValue('');
    this.formNumInt.setValue('');
    this.formCodPos.setValue('');
    this.formCiu.setValue('');
    this.formsEst.setValue('');
    this.formTel.setValue(null);
    this.formCor.setValue('');
    this.formPeso.setValue('');
    this.formLar.setValue('');
    this.formAnc.setValue('');
    this.formAlt.setValue('');
    this.tipoPaqueteList = [];
    this.formsPaqu.setValue('');
    this.tipo_empaque = "";
    this.formCusto.setValue('');

    this.formCall.reset();
    this.formColonia.reset();
    this.formNumExt.reset();
    this.formNumInt.reset();
    this.formCodPos.reset();
    this.formCiu.reset();
    this.formsEst.reset();
    this.formTel.reset();
    this.formCor.reset();
    this.formPeso.reset('');
    this.formLar.reset('');
    this.formAnc.reset('');
    this.formAlt.reset('');
    this.formsPaqu.reset('');
    this.formCusto.reset('');
  }

  async generarGuiaRetorno(){
    this.show_card_gen_gui = true;
    this.spinner = true;
    this.resetInputsGenGuiRet();
    await this.obtenerDireccion();
    this.spinner = false;    
  }

  async obtenerDireccion(){
    this.ticketService.consultarDireccionOrden(this.ord_id_rec)
      .pipe(first())
      .subscribe(
        data => {
          if(data["body"]["boxes"]){
            this.tipoPaqueteList = data["body"]["boxes"];
          }

          if(data["body"]["orden"]){
            let orden = data["body"]["orden"];

            this.formsPai.setValue('MX');
            let calle = (orden.calle != null ) ? orden.calle : "";
            this.formCall.setValue(calle);
            let colonia = (orden.colonia != null ) ? orden.colonia : "";
            this.formColonia.setValue(colonia);
            let numExt = (orden.noexterior != null ) ? orden.noexterior : "";
            this.formNumExt.setValue(numExt);
            let numInt = (orden.nointerior != null ) ? orden.nointerior : "";
            this.formNumInt.setValue(numInt);
            let codPos = (orden.codigo_postal != null ) ? orden.codigo_postal : "";
            this.formCodPos.setValue(codPos);
            let ciudad = (orden.ciudad != null ) ? orden.ciudad : "";
            this.formCiu.setValue(ciudad);
            var estado = (orden.estado != null ) ? orden.estado.toUpperCase() : "";
            this.formsEst.setValue(estado);
            let tel = (orden.telefono != null ) ? orden.telefono : "";
            this.formTel.setValue(tel);
            let correo = (orden.correo != null ) ? orden.correo : "";
            this.formCor.setValue(correo);
            let customer = (orden.customer != null ) ? orden.customer : "";
            this.formCusto.setValue(customer);
          }

          if(data["body"]["label"]){
            let paquete = data["body"]["label"];
            let peso = (paquete.peso_envio != null ) ? paquete.peso_envio : "";
            this.formPeso.setValue(peso);
            let largo = (paquete.largo != null ) ? paquete.largo : "";
            this.formLar.setValue(largo);
            let ancho = (paquete.ancho != null ) ? paquete.ancho : "";
            this.formAnc.setValue(ancho);
            let alto = (paquete.alto != null ) ? paquete.alto : "";
            this.formAlt.setValue(alto);
            let nomPaq = (paquete.nombre_empaque != null ) ? paquete.nombre_empaque : "";
            this.formsPaqu.setValue(nomPaq);
            let tipEmp = (paquete.tipo_empaque != null ) ? paquete.tipo_empaque : "";
            this.tipo_empaque = tipEmp;
          }

        },
        error => {
          this.spinner = false;
        }
      );
  }

  async generarGuia(){
    if(this.datos_tabla.length > 0 && this.entradaFinal.length > 0){
      if(this.verificarArreglo(this.datos_tabla) && this.verificarArreglo(this.entradaFinal)){
        if (this.formsPai.invalid || 
          this.formCall.invalid || 
          this.formColonia.invalid ||
          this.formNumExt.invalid ||
          this.formNumInt.invalid ||
          this.formCodPos.invalid ||
          this.formCiu.invalid ||
          this.formsEst.invalid ||
          this.formTel.invalid ||
          this.formCor.invalid ||
          this.formPeso.invalid ||
          this.formLar.invalid ||
          this.formAnc.invalid ||
          this.formAlt.invalid ||
          this.formsPaqu.invalid ||
          this.formCusto.invalid){
          return;
        }
        this.spinner = true;
        
        var datos_envio = {
          orden_id: this.ord_id_rec,  
          paquete_info: {
            "tipo_paquete": this.tipo_empaque,
            "asegurado": false,
            "tipo_envio": "economico"
          },  
          paquetes: [
            {
              "largo": this.formLar.value,
              "ancho": this.formAnc.value,
              "alto": this.formAlt.value,
              "peso": this.formPeso.value
            }
          ],
          origen:{
            "estado": this.formsEst.value,
            "colonia": this.formColonia.value,
            "calle": this.formCall.value,
            "no_ext": this.formNumExt.value,
            "no_int": this.formNumInt.value,
            "telefono": this.formTel.value,
            "codigo_postal": this.formCodPos.value,
            "nombre_contacto": this.formCusto.value,
            "email": this.formCor.value,
            "ciudad": this.formCiu.value,
            "pais": "Mexico",
            "codigo_pais": "MX",
            "company": this.formCusto.value
          },
          destino:{
            "estado": "Ciudad de Mexico",
            "colonia": "Naucalpan de Juarez",
            "calle": "Norte",
            "no_ext": "4, Industrial Alce Blanco",
            "no_int": null,
            "telefono": "5564034746",
            "codigo_postal": 53370,
            "nombre_contacto": "ZUBUT",
            "email": "soporte.fulfillment@zubut.com",
            "ciudad": "Ciudad de Mexico",
            "pais": "Mexico",
            "codigo_pais": "MX",
            "company": "ZUBUT"
          }
        };
        
        this.ticketService.generar_guia_devoluciones_api(datos_envio)
          .pipe(first())
          .subscribe(
            async data => {
              if(data.result.status == 200){
                await this.consultar_status_guia(datos_envio.orden_id);
              }else{
                this.spinner = false;
                this.snackBar.open("Error al generar la guía, intente más tarde.", "OK", {
                  duration: 5000,
                });
              }
            },
            error => {
              this.spinner = false;
            }
          );
      }else{
        this.snackBar.open("Error, los productos deben tener una cantidad mayor 0", "OK", {                      
          duration: 5000,
        });
      }
    }else{
      this.snackBar.open("Error, debe agregar al menos un producto en la tabla", "OK", {                      
        duration: 5000,
      });
    }
  }

  async consultar_status_guia(order_id){
    this.ticketService.consultar_sta_gui(order_id)
    .pipe(first())
    .subscribe(
      data => {
        if(data["body"]["result"].status == 200){
          var completado = false;
          var any_error = false;
          var datos_guia = null;
          var nom_paq = null;
          var text_error = "Error al generar la guía, intente más tarde.";
          if(data["body"]["result"]["informe_pipeline"].completado){
            if(data["body"]["result"]["guia"]){
              if(data["body"]["result"]["guia"].guia_creada){

                var isEmpty = Object.keys(data["body"]["result"]["guia"]["crear_guia"]).length === 0;
                if(!isEmpty){
                  if(data["body"]["result"]["guia"]["crear_guia"].status == 200){
                    completado = true;
                    datos_guia = data["body"]["result"]["guia"]["crear_guia"];
                    nom_paq = data["body"]["result"]["guia"]["shipping_company"].shipping_company;
                    window.open(data["body"]["result"]["guia"]["crear_guia"].url);
                  }else{
                    any_error = true;
                  }
                }
              }else{
                var isEmpty = Object.keys(data["body"]["result"]["guia"]["response_status"]).length === 0;
                if(!isEmpty){
                  if(data["body"]["result"]["guia"]["response_status"].status != 200){
                    text_error = data["body"]["result"]["guia"]["response_status"].message;
                    any_error = true;
                  }
                }

                var isEmpty2 = Object.keys(data["body"]["result"]["guia"]["crear_guia"]).length === 0;
                if(!isEmpty2){
                  if(data["body"]["result"]["guia"]["crear_guia"].status != 200){
                    text_error = data["body"]["result"]["guia"]["crear_guia"].message;
                    any_error = true;
                  }
                }
              }
            }
          }

          if(any_error){
            this.spinner = false;
            this.snackBar.open(text_error, "OK", {
              duration: 5000,
            });
          }else{
            if(completado){
              this.guardar_datos_devolucion(datos_guia, order_id, nom_paq);
            }else{
              setTimeout(() => {
                this.consultar_status_guia(order_id);
              }, 1000);
            }
          }
        }else{
          setTimeout(() => {
            this.consultar_status_guia(order_id);
          }, 1000);
        }
      },
      error => {
        this.spinner = false;
        this.snackBar.open("Error al generar la guía, intente más tarde.", "OK", {
          duration: 5000,
        });
    });
  }

  guardar_datos_devolucion(datos, order_id, nom_paq){
    this.ticketService.enviarDevolucion(this.datos_tabla, datos.tracking_number, nom_paq, this.usuario_gen_guia, this.checkInvRec.value, order_id, datos.file_name, this.t_token, this.ticketsTab2.motivo_seleccionado)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/tickets'], { queryParams: { order_id: order_id, t_token: this.t_token }});
          });
        }else{
          this.spinner = false;
          this.snackBar.open("Error al guardar los datos, intente más tarde.", "OK", {
            duration: 5000,
          });
        }
      },
      error => {
        this.spinner = false;
        this.snackBar.open("Error al guardar los datos, intente más tarde.", "OK", {
          duration: 5000,
        });
   });
  }

  cancelarGenGuia(){
    this.show_card_gen_gui = false;
  }

  updateTipoEmp(){
    let tipo_empa = this.formsPaqu.value;
    if(tipo_empa != null && tipo_empa != "" && tipo_empa != " "){
      for (let index = 0; index < this.tipoPaqueteList.length; index++) {
        if(this.tipoPaqueteList[index].nombre == tipo_empa){
          this.tipo_empaque = this.tipoPaqueteList[index].tipo_empaque;
          let largo = (this.tipoPaqueteList[index].largo != null ) ? this.tipoPaqueteList[index].largo : "";
          this.formLar.setValue(largo);
          let ancho = (this.tipoPaqueteList[index].ancho != null ) ? this.tipoPaqueteList[index].ancho : "";
          this.formAnc.setValue(ancho);
          let alto = (this.tipoPaqueteList[index].alto != null ) ? this.tipoPaqueteList[index].alto : "";
          this.formAlt.setValue(alto);
          break;
        }
      }
    }
  }

}

@Component({
  selector: 'dialog-pregunta-devolucion',
  templateUrl: './dialog-pregunta-devolucion.html',
})
export class DialogPreguntaDevolucion {}


@Component({
  selector: 'dialog-subir-guia',
  templateUrl: './dialog-subir-guia.html',
})
export class DialogSubirGuia {

  guiaForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  la_guia: string;
  mensaje_success = false;
  guiaFormGuia: FormControl;
  formPaqueteria: FormControl;
  paqueteriaFormGuia: FormControl;
  spinner = false;
  entrada_token: string;
  entrada_final: object;
  keywords = "";
  otra = false;
  paqueteria: string;
  usuario: string;
  checked = true;
  num_guia: string;
  checkInvRec: false;
  formFile: FormControl;
  fileToUpload: File = null;
  file_name: string;
  btn_disabled = false;
  t_token: any = null;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogSubirGuia>,
    private ticketService: TicketService,
    private authenticationService: AuthenticationService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
    if(this.data.entrada_final){
      this.entrada_final = this.data.entrada_final;
    }

    if(this.data.checkInvRec){
      this.checkInvRec = this.data.checkInvRec;
    }

    if(this.data.t_token){
      this.t_token = this.data.t_token;
    }

    this.authenticationService.currentUser.subscribe(x => this.usuario = x);
    if(this.usuario){
      this.usuario = this.usuario['seller_id'];
    }
  }

  ngOnInit(){
    this.guiaForm = this.formBuilder.group({
      guiaFormGuia: ['', Validators.required],
    });

    this.guiaFormGuia = new FormControl({value: '', disabled: false}, [
      Validators.required,
    ]);

    this.formPaqueteria = new FormControl({value: '', disabled: false}, [
      Validators.required,
    ]);

    this.paqueteriaFormGuia = new FormControl({value: '', disabled: false}, [Validators.required]);
    this.formFile = new FormControl('', );
  }

  seleccionar(){
    if(this.formPaqueteria.value == "otro"){
      this.otra = true;
    }else{
      this.otra = false;
    }
  }

  reload(){
    this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/tickets'], { queryParams: { order_id: this.data.ord_id_url, t_token: this.t_token }});
    });
  }

  guardarDevolucion(){
    if (this.guiaFormGuia.invalid || this.formPaqueteria.invalid || (this.otra && this.paqueteriaFormGuia.invalid)){
      return;
    }
    if (this.file_name == null){
      this.snackBar.open("Debe cargar el archivo de la guía", "OK", {                      
        duration: 3500,
      });
      return;
    }
    this.loading = true;
    this.spinner = true;

    this.mensaje_success = true;
    this.loading = false;
    this.spinner = false;

    if(this.otra){
      this.paqueteria = this.paqueteriaFormGuia.value;
    }else{
      this.paqueteria = this.formPaqueteria.value;
    }
    this.num_guia = this.guiaFormGuia.value;
    this.ticketService.enviarDevolucion(this.data.entrada_final, this.num_guia, this.paqueteria, this.usuario, this.checkInvRec, this.data.ord_id_url, this.file_name, this.t_token)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
        }else{
          this.error = data.body["message"];
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
   });
  }

  handleFileInput(files: FileList) {
    this.spinner = true;
    this.btn_disabled = true;
    this.formFile.disable();
    this.fileToUpload = files.item(0);
    this.ticketService.getUploadURl(this.fileToUpload.type)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.subirAWS(data.body["data"], this.fileToUpload);
        }else{

        }
      },
      error => {
    });
  }

  subirAWS(response, fileToUpload){
    this.ticketService.subirArchivo(response.url, fileToUpload)
    .pipe(first())
    .subscribe(
      data => {
        this.file_name = response.file_name;
        this.spinner = false;
        this.btn_disabled = false;
        this.formFile.enable();
        this.snackBar.open("La guía se cargó correctamente", "OK", {                      
          duration: 3500,
        });
      },
      error => {
        this.spinner = false;
        this.btn_disabled = false;
        this.formFile.enable();
        this.snackBar.open("Ocurrió un error al cargar la guía, intentelo de nuevo.", "OK", {                      
          duration: 3500,
        });
    });
  }

}

export class EntradaDatabaseItems {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(filtro: string): Observable<EntradabApi2> {
    const href = `${environment.apiUrl}/rmsfe/listar_items.json`;
    const requestUrl = `${href}?nombre_producto=${filtro}&min_quantity=0`;
    return this._httpClient.get<EntradabApi2>(requestUrl);
  }
  getListCli(filtro: string): Observable<EntradabApi2> {
    const href = `${environment.apiUrl}/rmsfe/listar_clientes_api.json`;
    const requestUrl = `${href}?nombre_cliente=${filtro}`;
    return this._httpClient.get<EntradabApi2>(requestUrl);
  }
}

@Component({
  selector: 'dialog-pregunta-fulfillment',
  templateUrl: './dialog-pregunta-fulfillment.html',
})
export class DialogPreguntaFulfillment {}

@Component({
  selector: 'dialog-generar-ff',
  templateUrl: './dialog-generar-ff.html',
})
export class DialogGenerarFF {

  guiaForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  la_guia: string;
  mensaje_success = false;
  guiaFormGuia: FormControl;
  formPaqueteria: FormControl;
  paqueteriaFormGuia: FormControl;
  checkForm: FormControl;
  spinner = false;
  entrada_token: string;
  entrada_final: object;
  keywords = "";
  otra = false;
  paqueteria: string;
  usuario: string;
  checked = false;
  formNombre: FormControl;
  formCorreo: FormControl;
  formTelefono: FormControl;
  formCalle: FormControl;
  formNumExterior: FormControl;
  formNumInterior: FormControl;
  formColonia: FormControl;
  formCiudad: FormControl;
  formEstado: FormControl;
  formCodigoPostal: FormControl;
  formCanal: FormControl;
  formNumOrden: FormControl;
  formTipoEnvio: FormControl;
  formAsegurar: FormControl;
  formFile: FormControl;
  formValorDeclarado : FormControl;
  formMontoCobrar : FormControl;
  hubo_error = false;
  datos_envio: object;
  file_name: string;
  orden_valida = false;
  fileToUpload: File = null;
  data_url: object;
  btn_disabled = false;
  tiene_guia = false;
  fulfillment_id: any;
  dataItemsCli: ItemsIssue[] = [];
  keywordsCli = "";
  entradaDatabase: EntradaDatabaseItems | null;
  toppingList: string[] = [];
  t_token: any;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogGenerarFF>,
    private ticketService: TicketService,
    private authenticationService: AuthenticationService,
    private router: Router,
    public dialog: MatDialog,
    private _httpClient: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any,
    ){
    if(this.data.entrada_final){
      this.entrada_final = this.data.entrada_final;
      this.tiene_guia = this.data.tiene_guia;
    }

    this.authenticationService.currentUser.subscribe(x => this.usuario = x);
    if(this.usuario){
      this.fulfillment_id = this.usuario['fulfillment_id'];
      this.usuario = this.usuario['seller_id'];  
    }

    if(this.data.t_token){
      this.t_token = this.data.t_token;
    }
  }

  ngAfterViewInit() {
    this.entradaDatabase = new EntradaDatabaseItems(this._httpClient);
  }

  ngOnInit(){
    this.entradaDatabase = new EntradaDatabaseItems(this._httpClient);
    this.hacerAutcompleteCli(this.keywordsCli);
    
    this.guiaForm = this.formBuilder.group({
      guiaFormGuia: ['', Validators.required],
    });

    this.guiaFormGuia = new FormControl({value: '', disabled: false}, [
      Validators.required,
    ]);

    this.formPaqueteria = new FormControl({value: '', disabled: false}, [
      Validators.required,
    ]);

    this.paqueteriaFormGuia = new FormControl({value: '', disabled: false}, [Validators.required]);

    this.checkForm = new FormControl('', []);
    this.checkForm.setValue(false);

    this.formNombre = new FormControl('', [Validators.required]);
    this.formCorreo = new FormControl('', [ Validators.email]);
    this.formTelefono = new FormControl('', [Validators.required]);
    this.formCalle = new FormControl('', [Validators.required]);
    this.formNumExterior = new FormControl('', [Validators.required]);
    this.formNumInterior = new FormControl('', []);
    this.formColonia = new FormControl('', [Validators.required]);
    this.formCiudad = new FormControl('', [Validators.required]);
    this.formEstado = new FormControl('', [Validators.required]);
    this.formCodigoPostal = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]);
    this.formCanal = new FormControl('', [Validators.required]);
    this.formNumOrden = new FormControl('', [Validators.required]);
    this.formPaqueteria = new FormControl('', [Validators.required]);
    this.formTipoEnvio = new FormControl('', [Validators.required]);
    this.formAsegurar = new FormControl('', []);
    this.formAsegurar.setValue(false);
    this.formFile = new FormControl('', );
    this.formValorDeclarado = new FormControl('', [Validators.required]);
    this.formMontoCobrar = new FormControl('', [Validators.required]);
  }

  seleccionar(){
    if(this.formPaqueteria.value == "otro"){
      this.otra = true;
    }else{
      this.otra = false;
    }
  }


  updateToppingList(){

    let tipo_envio = this.formTipoEnvio.value;
    switch (tipo_envio) {
      case 'CoD_next_day':
        this.toppingList = ['Mas económico'];
      break;
      case 'CoD_same_day':
        this.toppingList = ['Mas económico'];
      break;
      case 'mismo_dia':
        this.toppingList = ['Mas económico', '99m'];
      break;
      case 'dia_siguiente':
        if (this.tiene_guia){
          this.toppingList = ['Mas económico', 'Estafeta', 'FedEx', 'Internacional', 'will_call', 'Amazon','DHL', 'MercadoLibre','99m','tiui','otro'];
        }else{
          this.toppingList = ['Mas económico', 'Estafeta', 'FedEx', 'Internacional', '99m', 'tiui'];
        }
       
      break;
      case 'economico':
        if (this.tiene_guia){
          this.toppingList = ['Mas económico', 'AMPM','Estafeta', 'FedEx', 'Internacional', 'Paquetexpress', 'will_call', 'Amazon','DHL', 'MercadoLibre','99m','tiui','otro'];
        }else{
          this.toppingList = ['Mas económico', 'AMPM','Estafeta', 'FedEx', 'Internacional', 'Paquetexpress', '99m', 'tiui'];
        }
      break;
    
      default:
      break;
    }
  }

  reload(){
    if(this.hubo_error){
    }else{
      this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/']);
      });
    }
  }

  handleFileInput(files: FileList) {
    this.spinner = true;
    this.btn_disabled = true;
    this.formFile.disable();
    this.fileToUpload = files.item(0);
    this.ticketService.getUploadURl(this.fileToUpload.type)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.subirAWS(data.body["data"], this.fileToUpload);
        }else{
        }
      },
      error => {
    });
  }

  subirAWS(response, fileToUpload){
    this.ticketService.subirArchivo(response.url, fileToUpload)
    .pipe(first())
    .subscribe(
      data => {
        this.file_name = response.file_name;
        this.spinner = false;
        this.btn_disabled = false;
        this.formFile.enable();
        this.snackBar.open("La guía se cargó correctamente", "OK", {                      
          duration: 3500,
        });
      },
      error => {
        this.spinner = false;
        this.btn_disabled = false;
        this.formFile.enable();
        this.snackBar.open("Ocurrió un error al cargar la guía, intentelo de nuevo.", "OK", {                      
          duration: 3500,
        });
    });

  }

  guardarEntrada(){
    this.btn_disabled = true;
    if (this.tiene_guia == false){
      if(this.formNombre.invalid || this.formCorreo.invalid || this.formTelefono.invalid || this.formCalle.invalid 
        || this.formNumExterior.invalid || this.formNumInterior.invalid || this.formColonia.invalid 
        || this.formCiudad.invalid || this.formEstado.invalid || this.formCodigoPostal.invalid || this.formCanal.invalid 
        || this.formNumOrden.invalid || this.formPaqueteria.invalid || this.formTipoEnvio.invalid
        || this.formFile.invalid || (this.formAsegurar.value && this.formValorDeclarado.invalid) || ((this.formTipoEnvio.value == 'CoD_next_day' || this.formTipoEnvio.value == 'CoD_same_day') && this.formMontoCobrar.invalid)){
        this.btn_disabled = false;
        return;
      }
    }else{

      if(this.formCanal.invalid || this.formNumOrden.invalid || this.formPaqueteria.invalid || this.formTipoEnvio.invalid
        || this.formFile.invalid || (this.formAsegurar.value && this.formValorDeclarado.invalid) || ( (this.formTipoEnvio.value == 'CoD_next_day' || this.formTipoEnvio.value == 'CoD_same_day') && this.formMontoCobrar.invalid)){
        this.btn_disabled = false;
        return;
      }

      if (this.file_name == null){
        this.btn_disabled = false;
        this.snackBar.open("Debe cargar el archivo de la guía", "OK", {                      
          duration: 3500,
        });
        return;
      }
    }
    let nombreCli = "";
    if((typeof this.formNombre.value === 'object')){
      nombreCli = this.formNombre.value.nombre;
    }else{
      nombreCli = this.formNombre.value;
    }
    this.datos_envio = {
      Nombre: nombreCli,  
      Correo: this.formCorreo.value,  
      Telefono: this.formTelefono.value,  
      Calle: this.formCalle.value,  
      NumExterior: this.formNumExterior.value,  
      NumInterior: this.formNumInterior.value,  
      Colonia: this.formColonia.value,  
      Ciudad: this.formCiudad.value,  
      Estado: this.formEstado.value,  
      CodigoPostal: this.formCodigoPostal.value,  
      Canal: this.formCanal.value,  
      NumOrden: this.formNumOrden.value,  
      Paqueteria: this.formPaqueteria.value,  
      TipoEnvio: this.formTipoEnvio.value,  
      Asegurar: this.formAsegurar.value,  
      FileName: this.file_name,
      ValorDeclarado: this.formValorDeclarado.value,
      MontoPagar: this.formMontoCobrar.value
    }
                      
    this.ticketService.validarOrden(this.data.entrada_final, this.datos_envio, this.file_name)
    .pipe(first())
    .subscribe(
      data => {
        if(data["status"] == 200){
          this.mensaje_success = true;
          this.loading = true;
          this.spinner = true;
          this.hubo_error = false;
          this.loading = true;
          this.spinner = true;
          this.orden_valida = true;
          this.ticketService.enviarOrden(this.data.entrada_final, this.datos_envio, this.file_name, this.t_token)
            .pipe(first())
            .subscribe(
              data => {
                if(data.status == 200){
                  this.mensaje_success = true;
                  this.dialogRef.close(data["shopi_order_id"]);
                }else{
                  this.error = data["message"];
                  this.loading = false;
                  this.spinner = false;
                  this.hubo_error = true;
                }
              },
              error => {
                this.error = error;
                this.loading = false;
                this.spinner = false;
                this.hubo_error = true;
            });
        }else{
          this.snackBar.open("El Canal y numero de Orden ya existen.", "OK", {                      
            duration: 5000,
          });
        }
      },
      error => {
        this.orden_valida = false;
        this.error = error;
        this.loading = false;
        this.spinner = false;
        this.hubo_error = true;
    });
  }

  applyFilterCli(event: Event) {    
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywordsCli = filterValue.trim().toLowerCase();
    this.hacerAutcompleteCli(this.keywordsCli);
  }

  hacerAutcompleteCli(filtros){
    merge()
    .pipe(
      startWith({}),
      switchMap(() => {
        return this.entradaDatabase!.getListCli(filtros);
      }),
      map(data => {
        if(data.items.length == 0){
          this.reset_inputs_form();
        }
        return data.items;
      }),
      catchError(() => {
        return observableOf([]);
      })
    ).subscribe(data => this.dataItemsCli = data);
  }

  displayFnCli(subject){
    if(subject){
      return subject.nombre;
    }else{
      return undefined;
    }
  }

  onSelectCli(cliente){
    if(cliente){
      this.formCorreo.setValue(cliente.correo);
      this.formTelefono.setValue(cliente.telefono);
      this.formCalle.setValue(cliente.calle);
      this.formNumExterior.setValue(cliente.num_exterior);
      this.formNumInterior.setValue(cliente.num_interior);
      this.formColonia.setValue(cliente.colonia);
      this.formCiudad.setValue(cliente.ciudad);
      this.formEstado.setValue(cliente.estado);
      this.formCodigoPostal.setValue(cliente.codigo_postal);
    }
  }

  reset_inputs_form(){
    this.formCorreo.setValue('');
    this.formTelefono.setValue('');
    this.formCalle.setValue('');
    this.formNumExterior.setValue('');
    this.formNumInterior.setValue('');
    this.formColonia.setValue('');
    this.formCiudad.setValue('');
    this.formEstado.setValue('');
    this.formCodigoPostal.setValue('');
  }

}

export interface ProductosEntrada {
  sku: string;
  producto: string;
  cantidad: number;
}

@Component({
  selector: 'dialog-ff-1',
  templateUrl: './dialog-ff-1.html',
  styleUrls: ['./fulfillments.component.scss'],
})
export class DialogGuiaFF1 {
  params : any;
  usuario: string;
  datos_tabla: ProductosEntrada[] = []
  displayedColumns = ['sku', 'producto', 'cantidad'];
  order_id: any;
  spinner = false;
  datos_tabla_historial: HistorialOrden[] = []
  displayedColumnsOrden = ['event_time', 'event_name', 'nota_cliente'];
  t_token: any;
  order_id_rec: number = 0;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogGuiaFF1>,
    private ticketService: TicketService,
    private authenticationService: AuthenticationService,
    private router: Router,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
    if(this.data.params){
      this.params = this.data.params.body;
      this.datos_tabla = this.params["items"];
      this.order_id = this.params["orden"]["id"]
      this.datos_tabla = this.datos_tabla.filter((value,key)=>{
        return value;
      });
      this.datos_tabla_historial = this.params["historial"];
    }

    this.authenticationService.currentUser.subscribe(x => this.usuario = x);
    if(this.usuario){
      this.usuario = this.usuario['seller_id'];
    }

    if(this.data.t_token){
      this.t_token = this.data.t_token;
    }

    if(this.data.order_id){
      this.order_id_rec = this.data.order_id;
    }
  }

  ngOnInit(){
  }

  closeDialog() {
    this.dialogRef.close('Pizza!');
    this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/tickets'], { queryParams: { order_id: this.order_id_rec, t_token: this.t_token }});
    });
  }

  reload(){
    this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
        this.router.navigate(['../entradas', 'tab1']);
    });
  }

}

@Component({
  selector: 'dialog-pregunta-reabrir',
  templateUrl: './dialog-pregunta-reabrir.html',
})
export class DialogPreguntaReabrir {}
